import { isDevHost, isStagingHost } from "@/lib/web";

export const IS_NARROW_CUTOFF = 380;

export const FORCE_PROD_LOGGING = true;

export const APP_STORE_LINKS = {
  ios: "https://apps.apple.com/app/taalia/6503200372",
  android: "https://play.google.com/store/apps/details?id=dev.empirical.Taalia",
};

export function doLog() {
  const queryParams = new URLSearchParams(window.location.search);
  const log = queryParams.get("log");
  return isDevHost || isStagingHost || FORCE_PROD_LOGGING || log === "true";
}

export const APP_ID = "53@5sd+7f7";
